import { render, staticRenderFns } from "./cowMatingProgramme.vue?vue&type=template&id=52fc0b0c&scoped=true&"
import script from "./cowMatingProgramme.vue?vue&type=script&lang=js&"
export * from "./cowMatingProgramme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fc0b0c",
  null
  
)

export default component.exports